import { url } from '../../axios/api_urls/comment'
const api = require('../../axios/request')
const saveUrlMap = {
  concept: '/auth/concept/comment/save',
  formulation: '/auth/formulation/comment/save',
  product: '/auth/trade/comment/save',
  trend: '/auth/trend/comment/save',
  inci: '/auth/trade/inci/comment/save'
}
const getListUrlMap = {
  concept: '/auth/concept/comment/findList',
  formulation: '/auth/formulation/comment/findList',
  product: '/auth/trade/comment/findList',
  trend: '/auth/trend/comment/findList',
  inci: '/auth/trade/inci/comment/findList'
}
const getDetailUrlMap = {
  concept: '/auth/concept/comment/find',
  formulation: '/auth/formulation/comment/find',
  product: '/auth/trade/comment/find',
  trend: '/auth/trend/comment/find',
  inci: '/auth/trade/inci/comment/find'
}
const state = {
  moduleNumberList: {
    trend:263,
    concept:264,
    consumerProduct:265,
    formulation:266,
    product: 271,
    inci: 272,
    eLearning: 273,
    brand: 283
  }
}
const getters = {
  moduleNumberList: state => state.moduleNumberList
}
const mutations = {}
const actions = {
  getList (context, payload) {
    const { moduleNumber, refId, expert, current, size, type } = payload
    const params = {
      moduleNumber,
      refId,
      expert,
      current,
      size
    }
    const url = getListUrlMap[payload.type]
    return api._post(url, params)
  },
  saveComment (context, payload) {
    const { refId, comment, score, source, pid, keywordScoreList, type } = payload
    const params = {
      refId,
      comment,
      score,
      source,
      pid,
      keywordScoreList
    }
    const url = saveUrlMap[type]
    return api._post(url, params)
  },
  getDetail (context, payload) {
    const { id, type } = payload
    const url = getDetailUrlMap[type]
    return api._post(url, { id })
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/comment.js